define('flight-components/ResponseModeToolbar',[
  'flight/lib/component',
  'flight-components/mixins/withActions',
  'URIjs/URI',
  'cookies'
],
function (defineComponent, withActions, URI) {

  var ResponseModeToolbar = function ResponseModeToolbar() {

    this.defaultAttrs({
      commandCookieKey: 'VPWEB_COMMAND' ,
      procListSelector: '.response-mode-toolbar__proclist',
    });

    this.isArray = function(obj) {
      return (typeof obj.length !== 'undefined' && typeof obj === 'object');
    };

    this.init = function() {
      var self = this;
      var responseMode = this.attr.responseMode = this.$node.data('responseMode');
      console.info('Response mode: ' + this.attr.responseMode);  
    }; 


    this.clearCommands = function() {
      $.removeCookie(this.attr.commandCookieKey, {path: '/'});
      this.$node.remove();
      this.teardown();
    };   



    this.after('initialize', function () {
      this.init();     
    });

  };

  return defineComponent(ResponseModeToolbar, withActions);
});

